





























































import { Button, Form, Field,Picker,Toast,Popup,Tab, Tabs } from "vant";
import position from './components/position.vue'
import fund from './components/fund.vue'
import deal from './components/deal.vue'
import entrust from './components/entrust.vue'
export default {
  components: {
    [Button.name]: Button,
    [Form.name]: Form,
    [Field.name]: Field,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    position,
    fund,
    deal,
    entrust
  },
  data() {
    return {
      groupColumns: ['按组查', '按账户'],
      accountColumns: ['杭州', '宁波', '温州', '绍兴', '湖州', '嘉兴', '金华', '衢州'],
      overlayShow:false,
      sonOverlayShow:false,
      activeTab:0,
      curGroup:{
          value:"按组查",
          index:0
      },
      curSonGroup: {
        index: 0
      },
      curSelect:'',
      queryParem:{
          aroupType:0,
          type:0,
          account:''
      }
    };
  },
  created(){
      (this as any).getSelect()
  },
  computed:{
      columnsOption(){
          if((this as any).accountColumns && (this as any).accountColumns.length > 0){
            if((this as any).curGroup.index === 0){
              return (this as any).accountColumns.map(item => {
                return item.group_name
              })
            }else if((this as any).curGroup.index === 1){
              return (this as any).accountColumns.map(item => {
                return item.futures_login_id
              })
            }
          }
      },
    isSecurities(){
        return (this as any).curGroup.value == "按组查" && (this as any).curSelect == "证券账户组"
    }
  },
  methods: {
      getSelect(){
          if((this as any).curGroup.index === 0){
              (this as any).$apis
              .getGroupList({show_account:1})
              .then(res => {
                  if(res[0]){
                      (this as any).accountColumns = res;
                      (this as any).curSelect = res[0].group_name || '无';
                      (this as any).queryParem.account = res[0].account_list.join();
                      (this as any).queryParem.type = res[0].type
                  }else{
                      (this as any).curSelect = '无';
                      (this as any).accountColumns = [];
                  }
              })
              .catch(e => {
                  
              });
          }else if((this as any).curGroup.index === 1){
              (this as any).$apis
              .getAccountList()
              .then(res => {
                  if(res[0]){
                      (this as any).accountColumns = res;
                      (this as any).curSelect = res[0].futures_login_id;
                      (this as any).queryParem.account = res[0].futures_login_id;
                      (this as any).queryParem.type = res[0].group_id
                  }else{
                      (this as any).curSelect = '无';
                      (this as any).accountColumns = [];
                  }

              })
              .catch(e => {
                  
              });
          }

      },
      onConfirm(value, index) {
          (this as any).curGroup = { value, index };

          (this as any).queryParem.aroupType = index;
          (this as any).getSelect();
          (this as any).overlayShow = false;
      },
      onChange(picker, value, index) {
          
      },
      onCancel() {
          
          (this as any).overlayShow = false
      },
      onSonConfirm(value, index) {
        (this as any).curSonGroup = {
            value, index
          }
          
          if((this as any).curGroup.index === 0){
              (this as any).queryParem.type = (this as any).accountColumns[index].type;
              (this as any).queryParem.account = (this as any).accountColumns[index].account_list.join();
              (this as any).curSelect = (this as any).accountColumns[index].group_name || '无';
              
          }else if((this as any).curGroup.index === 1){
              (this as any).queryParem.account = (this as any).accountColumns[index].futures_login_id;
              (this as any).queryParem.type = (this as any).accountColumns[index].group_id;
              (this as any).curSelect = (this as any).accountColumns[index].futures_login_id || '无';
          }

          (this as any).sonOverlayShow = false;

      },
      onSonChange(picker, value, index) {
          
        // (this as any).curSonGroup = {value, index};
      },
      onSonCancel() {
          
          (this as any).sonOverlayShow = false
      },
  }
};
